export default function sanitizeGraphqlObject(obj) {
  if (!obj) {
    return obj;
  }

  return { ...obj, __typename: undefined };
}
